import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 新增 ");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("设为招募中");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("设为已结束");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("下架");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("查看");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("编辑");

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus';
import { getRecruitNoticeList, recruitNoticeUpdateStatus, recruitNoticeUpdateTop } from '@/request';
import { getVexTableProps } from '@/config';
export default {
  name: 'RecruitNoticeList',

  setup(__props) {
    const router = useRouter();
    const form = ref({
      title: '',
      status: '',
      sponsorKeyword: ''
    });
    const table = ref();
    const statusMap = {
      1: '招募中',
      2: '已结束',
      3: '下架'
    };
    const tableOptions = getVexTableProps({
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        field: 'title',
        title: '公告标题',
        minWidth: '180px',
        showOverflow: true
      }, {
        field: 'contactName',
        title: '联系人',
        width: '100px',
        showOverflow: true
      }, {
        field: 'contactPhone',
        title: '联系电话',
        width: '130px',
        showOverflow: true
      }, {
        field: 'productNames',
        title: '关联品种',
        minWidth: '160px',
        showOverflow: true
      }, {
        field: 'sponsorSummary',
        title: '发起人',
        minWidth: '140px',
        showOverflow: true
      }, {
        field: 'regionSummary',
        title: '招募区域',
        minWidth: '160px',
        showOverflow: true
      }, {
        field: 'recruitCount',
        title: '招募人数',
        width: '100px'
      }, {
        field: 'appliedCount',
        title: '已报名',
        width: '90px'
      }, {
        field: 'publishDate',
        title: '发布日期',
        width: '120px'
      }, {
        field: 'deadline',
        title: '截止日期',
        width: '120px'
      }, {
        field: 'status',
        title: '状态',
        width: '100px',

        formatter({
          cellValue
        }) {
          return statusMap[cellValue] || '-';
        }

      }, {
        field: 'createBy',
        title: '创建人',
        width: '120px',
        showOverflow: true
      }, {
        field: 'updateAt',
        title: '更新时间',
        width: '170px'
      }, {
        title: '操作',
        fixed: 'right',
        width: '250px',
        slots: {
          default: 'operation'
        }
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getRecruitNoticeList({
              page: page.currentPage,
              pageSize: page.pageSize,
              title: form.value.title,
              status: form.value.status === '' ? undefined : form.value.status,
              sponsorKeyword: form.value.sponsorKeyword
            }).then(data => {
              res({
                total: data.data.totalSize,
                result: data.data.list
              });
            });
          })
        }
      }
    });

    function reset() {
      form.value = {
        title: '',
        status: '',
        sponsorKeyword: ''
      };
      table.value.commitProxy('reload');
    }

    function goEdit(row, isSee) {
      router.push({
        name: 'SaveRecruitHireNotice',
        query: {
          id: row.recruitId,
          isSee: isSee ? '1' : undefined
        }
      });
    }

    function updateTop(row) {
      const isTop = row.isTop === 1 ? 0 : 1;
      const actionStr = isTop === 1 ? '置顶' : '取消置顶';
      ElMessageBox.confirm(`确定将「${row.title}」${actionStr}吗？`, {
        title: actionStr
      }).then(() => {
        recruitNoticeUpdateTop({}, {
          params: {
            recruitId: row.recruitId,
            isTop,
            __repeat: true,
            __warn: true
          }
        }).then(data => {
          if (data.success) {
            ElMessage.success(actionStr + '成功!');
            table.value.commitProxy('reload');
          }
        });
      });
    }

    function updateStatus(status) {
      const label = statusMap[status];
      const rows = table.value.getCheckboxRecords();

      if (!rows.length) {
        ElMessage.warning('请选择公告');
        return;
      }

      ElMessageBox.confirm(`是否确认${label}`, {
        title: label
      }).then(() => {
        recruitNoticeUpdateStatus({}, {
          params: {
            status,
            recruitIdList: rows.map(r => r.recruitId).join(','),
            __repeat: true,
            __warn: true
          }
        }).then(() => {
          ElMessage.success('操作成功');
          table.value.commitProxy('reload');
        });
      });
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, null, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "公告标题"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.title = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "状态"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.status,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.status = $event),
                placeholder: ""
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }), _createVNode(_component_el_option, {
                  label: "招募中",
                  value: 1
                }), _createVNode(_component_el_option, {
                  label: "已结束",
                  value: 2
                }), _createVNode(_component_el_option, {
                  label: "下架",
                  value: 3
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "发起人"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.sponsorKeyword,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.sponsorKeyword = $event),
                placeholder: "姓名"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        justify: "end"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Search",
          onClick: _cache[3] || (_cache[3] = $event => table.value.commitProxy('reload'))
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          icon: "Refresh",
          onClick: reset
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        tools: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Plus",
          onClick: _cache[4] || (_cache[4] = $event => _unref(router).push({
            name: 'SaveRecruitHireNotice'
          }))
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "success",
          onClick: _cache[5] || (_cache[5] = $event => updateStatus(1))
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "warning",
          onClick: _cache[6] || (_cache[6] = $event => updateStatus(2))
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "danger",
          onClick: _cache[7] || (_cache[7] = $event => updateStatus(3))
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        })]),
        operation: _withCtx(({
          row
        }) => [_createVNode(_component_el_button, {
          type: "success",
          onClick: $event => goEdit(row, true)
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_button, {
          type: "primary",
          onClick: $event => goEdit(row, false)
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_button, {
          type: row.isTop === 1 ? 'warning' : 'info',
          onClick: $event => updateTop(row)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(row.isTop === 1 ? '取消置顶' : '置顶'), 1)]),
          _: 2
        }, 1032, ["type", "onClick"])]),
        _: 1
      }, 16)]);
    };
  }

};